// extracted by mini-css-extract-plugin
export default {"othersRegnJumbotron":"AdminHome_othersRegnJumbotron__G87-0","regnJumbotron":"AdminHome_regnJumbotron__r2SwL"};